import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot} from '@angular/router';
import {AdminService} from '../service/admin.service';
import {inject} from '@angular/core';

/**
 * @description This function is used to determine if the current user is an authenticated administrator.
 * @export
 * @function
 * @name AdministratorGuard
 * @param {ActivatedRouteSnapshot} _ The activated route snapshot.
 * @param {RouterStateSnapshot} state The router state snapshot.
 * @returns {boolean} Returns true if the user is an authenticated administrator; otherwise, false.
 */
export const AdministratorGuard: CanActivateFn = (_: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {

  // Check for an existing session that is valid then return if the check was successful.
  if (inject(AdminService).online()) return true;

  // Redirect the user to the sign-in page.
  inject(Router).navigate(['/admin/sign-in'], {queryParams: {returnUrl: state.url}}).then((): void => {
  });

  // We're done, the user is not an authenticated administrator.
  return false;
};
